<template>
	<div class="bg-white px-3 goods_create" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{name:'rcgl_ddcl_jhdd'}" style="position: absolute;top: 32px;left: 200px;">
			<el-button size="mini">回到加货订单</el-button>
		</router-link>
		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 25%;">
					<el-form-item label="客户名称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" :disabled="true">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="客户简称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" :disabled="true">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="编号">
						<el-select v-model="lists.bh" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in bhlist" :key="item.id" :label="item.bh" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="日期">
						<el-date-picker v-model="lists.ddrq" align="right" type="date" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 90%;"
						      :picker-options="pickerOptions">
						    </el-date-picker>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 33%;">
					<el-form-item label="存储方式">
						<el-select v-model="lists.ccfs" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in ccfslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<div class="d-flex">
						<div style="width: 50%;">
							<el-form-item label="计费单位">
								<el-select v-model="lists.jfdw" disabled style="width: 90%;" size="mini">
								    <el-option v-for="item in jfdwlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="width: 50%;" v-if="lists.jfdw == 2">
							<el-form-item label="计费模式">
								<el-select v-model="lists.jfms" style="width: 90%;" size="mini">
								    <el-option v-for="item in jfmslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
				</div>
				<div style="width: 34%;">
					<el-form-item label="计费标准">
						<el-select v-model="lists.jfbz" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in jfbzlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="计费周期">
						<el-select v-model="lists.jfzq" filterable style="width: 90%;" size="mini" :disabled="true">
						    <el-option v-for="item in jfzqlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="货物类型">
						<el-select v-model="lists.hwlx" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in hwlxlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="仓库">
						<el-select v-model="lists.ck_id" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 33%;">
					<el-form-item label="其他费用">
						<div class="d-flex">
							<el-checkbox v-model="lists.flfy">分类费用</el-checkbox>
							<el-checkbox v-model="lists.gcf">过车费</el-checkbox>
						</div>
						<div class="d-flex">
							<el-checkbox v-model="lists.yf">运费</el-checkbox>
							<el-checkbox v-model="lists.lmf">拉膜费</el-checkbox>
						</div>
						
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="订单属性">
						<el-select v-model="lists.ddsx" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in ddsxlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="备注">
						<el-input v-model="lists.desc" style="width: 95%;" type="textarea" :rows="2"></el-input>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 25%;">
					<el-form-item label="分类费类型" v-if="lists.flfy == true">
						<el-select v-model="lists.flfylx" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in flfylxlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="过车费" v-if="lists.gcf == true">
						<el-input-number v-model="lists.zgcf" :precision="2" size="mini"></el-input-number>
						<span style="color: #0091ff;margin-left: 8px;">元</span>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="运费" v-if="lists.yf == true">
						<el-input-number v-model="lists.zyf" :precision="2" size="mini"></el-input-number>
						<span style="color: #0091ff;margin-left: 8px;">元</span>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="拉膜费" v-if="lists.lmf == true">
						<el-input-number v-model="lists.lmfdj" :precision="2" size="mini"></el-input-number>
						<span style="color: #0091ff;margin-left: 8px;">{{lmfdw}}</span>
					</el-form-item>
				</div>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 180px;">
				<div class="m-4 d-flex">
					<div>货物信息</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="rcddhw" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
						<el-table-column align="center" width="74" fixed="left">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button type="danger" size="mini" icon="el-icon-delete" @click="pustyldel(scope.$index)"></el-button>
							</template>
						</el-table-column>
						<el-table-column type="index" label="序号" width="50" align="center" fixed="left"></el-table-column>
						<el-table-column prop="hwmc" label="货物名称" width="80" fixed="left"></el-table-column>
						<el-table-column label="客称" align="center" width="160">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.kc"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="bh" label="条码" width="120" align="center"></el-table-column>
						<el-table-column label="包装叫法" align="center" width="160">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.bzjf"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="包装" align="center" width="110">
							<template slot-scope="scope">
								<el-select v-model="scope.row.hwbz" style="width: 100%;" size="mini">
								    <el-option v-for="item in hwbzlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="jcrq" label="进仓日期" align="center" width="120"></el-table-column>
						<el-table-column label="运费单价" align="center" width="150">
							<template slot-scope="scope">
								<div class="d-flex">
									<el-input size="mini" v-model="scope.row.yfdj" style="width: 50%;"></el-input>
									<div style="margin-left: 3px;margin-right: 3px;">/</div>
									<el-select v-model="scope.row.yfdw" style="width: 50%;" size="mini">
									    <el-option v-for="item in jfdwlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="长度(米)" align="center" width="140">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.cd" style="width: 90%;" :min='0' :precision="2" @change="handjstj(scope.row.cd,scope.row.kd,scope.row.gd,scope.$index,scope.row.js,scope.row.mjzl,scope.row.dwzl,scope.row.dwgd)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="宽度(米)" align="center" width="140">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.kd" style="width: 90%;" :min='0' :precision="2" @change="handjstj(scope.row.cd,scope.row.kd,scope.row.gd,scope.$index,scope.row.js,scope.row.mjzl,scope.row.dwzl,scope.row.dwgd)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="高度(米)" align="center" width="140">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.gd" style="width: 90%;" :min='0' :precision="2" @change="handjstj(scope.row.cd,scope.row.kd,scope.row.gd,scope.$index,scope.row.js,scope.row.mjzl,scope.row.dwzl,scope.row.dwgd)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column :label="lists.jfms == 0 ? '单位重量(kg)' : '单位高度(米)'" align="center" width="150" v-if="lists.jfdw == 2">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.dwzl" style="width: 90%;" :min='0' @change="handjstj(scope.row.cd,scope.row.kd,scope.row.gd,scope.$index,scope.row.js,scope.row.mjzl,scope.row.dwzl,scope.row.dwgd)" v-if="lists.jfms == 0"></el-input-number>
								<el-input-number size="mini" v-model="scope.row.dwgd" style="width: 90%;" :min='0' @change="handjstj(scope.row.cd,scope.row.kd,scope.row.gd,scope.$index,scope.row.js,scope.row.mjzl,scope.row.dwzl,scope.row.dwgd)" v-else></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="每件重量(kg)" align="center" width="150">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.mjzl" style="width: 90%;" :min='0' :precision="2" @change="handjstj(scope.row.cd,scope.row.kd,scope.row.gd,scope.$index,scope.row.js,scope.row.mjzl,scope.row.dwzl,scope.row.dwgd)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="件数" align="center" width="130">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.js" style="width: 90%;" :min='0' @change="handjstj(scope.row.cd,scope.row.kd,scope.row.gd,scope.$index,scope.row.js,scope.row.mjzl,scope.row.dwzl,scope.row.dwgd)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="mj" label="总面积" align="center" width="80"></el-table-column>
						<el-table-column prop="tj" label="总体积" align="center" width="80"></el-table-column>
						<el-table-column prop="zzl" label="总重量" align="center" width="80"></el-table-column>
						<el-table-column prop="bzdsl" align="center" label="板可方最大件数" width="120"></el-table-column>
						<el-table-column prop="bsl" align="center" label="板数量" width="70"></el-table-column>
						<el-table-column prop="jfsl" label="计费数量" align="center" width="90">
							<template slot-scope="scope">
								{{scope.row.jfsl}}{{lmfdw}}
							</template>
						</el-table-column>
						<el-table-column prop="" label="单件面积" align="center" width="80">
							<template slot-scope="scope">
								{{scope.row.djmj}}平方
							</template>
						</el-table-column>
						<el-table-column prop="" label="单件体积" align="center" width="80">
							<template slot-scope="scope">
								{{scope.row.djtj}}立方
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>
		<el-dialog title="选择货物" :visible.sync="createModel" top="5vh" customClass="customWidth">
			<button-search class="" placeholder="货物名称" @search="searchEvent">
				<template #form>
					<el-form inline ref="form" :model="search" label-width="80px">
						<!-- 搜索内容 -->
						<el-form-item label="货物编号" class="mb-0">
							<el-input v-model="search.bh" size="mini" placeholder="货物编号"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
							<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="ckcplist" tooltip-effect="dark" height="420" size="mini" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="bh" label="编号" width="90"></el-table-column>
					<el-table-column prop="name" label="货物名称" width="180"></el-table-column>
					<el-table-column prop="mj" label="面积" align="center"></el-table-column>
					<el-table-column prop="tj" label="体积" align="center"></el-table-column>
					<el-table-column prop="zl" label="重量" align="center"></el-table-column>
				</el-table>
			</div>
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="1" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submits(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="width: 160px;margin-left: 30px;">经办人：<span style="color: #0091ff;">{{user.name}}</span></div>
			<div style="width: 120px;">共<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{lists.hwxm}}</span>项</div>
			<div style="width: 190px;">
				计费数量：
				<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{jfsl}}</span>
				<span style="color: #0091ff;">{{lmfdw}}</span>
			</div>
			<div style="width: 190px;">
				合计：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{hj}}</span><span style="color: #0091ff;">{{lmfdw}}</span>
			</div>
			<div style="width: 160px;">运费：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{lists.zyf}}</span>元</div>
			<el-button type="primary" @click="submit" style="margin-left: 10%;">提交</el-button>
		</el-footer>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import buttonSearch from '@/components/common/button-search.vue';
	import common from '@/common/mixins/common.js';
	export default {
		mixins: [common],
		inject: ['app', 'layout'],
		components: {
			buttonSearch
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}]
				},
				jfsl:0,
				zzl:0,
				hj:0,
				lists: {
				},
				ywylist:[],
				khlist:[],
				cklist:[],
				ckcplist:[],
				bmlist:[],
				valuea: false,
				createModel: false,
				preUrl: 'cpgl',
				multipleSelection:[],
				rcddhw:[],
				
				
				lmfdw:'',
				tableDatab:[],
				
				hwlxlist:[],
				ccfslist:[],
				jfdwlist:[],
				jfbzlist:[],
				hwbzlist:[],
				bhlist:[],
				jfzqlist: [{
					id: 1,
					name: '1天'
				}, {
					id: 3,
					name: '3天'
				}, {
					id: 7,
					name: '7天'
				}, {
					id: 10,
					name: '10天'
				}],
				ddsxlist: [{
					id: 0,
					name: '散货'
				}, {
					id: 1,
					name: '大货'
				}],
				jfmslist: [{
					id: 0,
					name: '重量'
				}, {
					id: 1,
					name: '体积'
				}],
				flfylxlist: [],
				search: {
					keyword: "",
					bh:''
				},
				bantj:1.68 //每板体积
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),
		

			
		},
		created() {
			this.lists = this.$route.params.data;
			this.hj = this.lists.hj
			this.jfsl = this.lists.jfsl
			if(this.lists.id == 0){
				this.axios.get('/admin/jh/rcdd', { token: true }).then(res => {
					this.bhlist = res.data.data;
				});
			}
			if(this.lists.hwxm != 0){
				this.rcddhw = this.lists.rcddhw
			}
			
			this.axios.get('/admin/flflx/1', { token: true }).then(res => {
				this.flfylxlist = res.data.data.list;
			});
			this.axios.get('/admin/ccfs/1', { token: true }).then(res => {
				this.ccfslist = res.data.data.list;
			});
			this.axios.get('/admin/khxxs', { token: true }).then(res => {
				this.khlist = res.data.data;
			});
			this.axios.get('/admin/cangkus', { token: true }).then(res => {
				this.cklist = res.data.data;
			});
			
			this.axios.get('/admin/hwlx/1', { token: true }).then(res => {
				this.hwlxlist = res.data.data.list;
			});
			this.axios.get('/admin/jfdw/1', { token: true }).then(res => {
				this.jfdwlist = res.data.data.list;
				if(this.lists.id){
					let datas = this.jfdwlist.filter(item=>{
						return item.id == this.lists.jfdw
					})
					console
					this.lmfdw = datas[0].name
				}
			});
			
			this.axios.get('/admin/jfbz/1', { token: true }).then(res => {
				this.jfbzlist = res.data.data.list;
			});
			
			this.axios.get('/admin/hwbz/1', { token: true }).then(res => {
				this.hwbzlist = res.data.data.list;
			});
			
		},
		methods: {
			curr(val){
				console.log(val)
				console.log(this.bhlist)
				let data = this.bhlist.filter(item=>{
					return item.id == val
				})
				console.log(data)
				this.lists.bh = data[0].bh
				this.lists.pch = data[0].pch
				this.lists.lmfdj = data[0].lmfdj
				this.lists.jfdw = data[0].jfdw
				this.lists.jfzq = 1
				this.lists.yfdj = 80
				this.lists.flfylx = data[0].flfylx
				this.lists.ck_id = data[0].ck_id
				this.lists.ccfs = data[0].ccfs
				this.lists.hwlx = data[0].hwlx
				this.lists.jfbz = data[0].jfbz
				this.lists.kh_id = data[0].kh_id
				this.rcddhw = data[0].rcddhw.map(item=>{
					return {
						kh_id:item.kh_id,
						bh:item.bh,
						hwmc:item.hwmc,
						kc:item.kc,
						bzjf:item.bzjf,
						hwbz:item.hwbz,
						yfdj:item.yfdj,
						yfdw:item.yfdw,
						jcrq:this.lists.ddrq,
						cd:item.cd,
						kd:item.kd,
						gd:item.gd,
						dwzl:item.dwzl,
						dwgd:item.dwgd,
						mjzl:item.mjzl,
						js:0,
						mj:0,
						djmj:0,
						djtj:0,
						bzdsl:0,
						bsl:0,
						tj:0,
						jfsl:0,
						zzl:0
					}
				})
				this.lists.hwxm = this.rcddhw.length
				let datas = this.jfdwlist.filter(item=>{
					return item.id == data[0].jfdw
				})
				this.lmfdw = datas[0].name
			},

			pustyl() {
				if(!this.lists.kh_id){
					this.$message({
						type: "warning",
						message: "请先选择客户"
					})
				}else{
					this.createModel = true;
				}
			},
			pustyldel(e) {
				this.rcddhw.splice(e,1)
				this.lists.hwxm = this.rcddhw.length
			},
			submits(e) {
				this.lists.hwxm = e.length
				this.rcddhw = e.map(i=>{
					return {
						bh:this.lists.bh+'-'+i.bh,
						kh_id:this.lists.kh_id,
						hwmc:i.name,
						kc:'',
						bzjf:'',
						hwbz:'',
						jcrq:this.lists.ddrq,
						yfdj:this.lists.yfdj,
						yfdw:this.lists.jfdw,
						cd:0,
						kd:0,
						gd:0,
						dwzl:i.zl,
						dwgd:0,
						mjzl:0,
						js:0,
						mj:0,
						djmj:0,
						djtj:0,
						bzdsl:0,
						bsl:0,
						tj:0,
						jfsl:0,
						zzl:0
					}
				})
				this.createModel = false;
			},
			getListUrl() {
				
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&keyword=${this.search.keyword}&bh=${this.search.bh}`
			},
			getListResult(e) {
				this.ckcplist = e.list;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			handleChange(lx,e,index) {
				if(lx == 'sl'){
					this.rcddhw[index].hj = this.rcddhw[index].dj * this.rcddhw[index].sl
				}else if(lx == 'dj'){
					this.rcddhw[index].hj = this.rcddhw[index].dj * this.rcddhw[index].sl
				}else{
					this.rcddhw[index].dj = this.rcddhw[index].hj / this.rcddhw[index].sl
				}
				this.lists.spze = 0
				for(let i of this.rcddhw){
					this.lists.spze += i.hj
				}
				this.lists.ddje = this.lists.spze * (this.lists.sl/100) + this.lists.spze
			},
			handleChanges(e){
				this.lists.ddje = this.lists.spze * (e/100) + this.lists.spze
			},
			// 计算体积
			handjstj(cd,kd,gd,index,js,zl,dwzl,dwgd){
				zl = zl / 1000
				this.rcddhw[index].djmj = (cd * kd).toFixed(2)
				this.rcddhw[index].djtj = (cd * kd * gd).toFixed(2)
				this.rcddhw[index].mj = (cd * kd * js).toFixed(2)
				this.rcddhw[index].tj = (cd * kd * gd * js).toFixed(2)
				
				let mjtj = (cd * kd * gd).toFixed(2)

				this.rcddhw[index].bzdsl = Math.floor(this.bantj / mjtj)
				this.rcddhw[index].bsl = Math.ceil(js / this.rcddhw[index].bzdsl).toFixed(2)
				if(this.lists.jfdw == 1){ // 吨
					this.rcddhw[index].jfsl = (zl * js).toFixed(2) // 计费数量
					this.rcddhw[index].zzl = (zl * js).toFixed(2) // 总重量
					let jfsl = 0
					let zzl = 0
					let hj = 0
					for(let i of this.rcddhw){
						jfsl += parseFloat(i.jfsl)
						zzl += parseFloat(i.zzl)
					}
					
					this.jfsl = jfsl.toFixed(2)
					this.zzl = zzl.toFixed(2)
					hj = jfsl
					
					if(jfsl < 0.5){
						hj = 0.5
					}
					this.hj = hj.toFixed(2)
				}else if(this.lists.jfdw == 2){ // 平方
					if(this.lists.jfms == 0){ // 重量
						this.rcddhw[index].jfsl = (js * zl / (dwzl/1000)).toFixed(2)
						console.log(this.rcddhw[index].jfsl)
						this.rcddhw[index].zzl = (zl * js).toFixed(2) // 总重量
						let jfsl = 0
						let zzl = 0
						let hj = 0
						for(let i of this.rcddhw){
							jfsl += parseFloat(i.jfsl)
							zzl += parseFloat(i.zzl)
						}
						
						this.jfsl = jfsl.toFixed(2)
						this.zzl = zzl.toFixed(2)
						hj = jfsl
						
						this.hj = hj.toFixed(2)
					}else{ // 体积
						this.rcddhw[index].jfsl = ((cd * kd * gd) / dwgd * js).toFixed(2)
						this.rcddhw[index].zzl = (zl * js).toFixed(2) // 总重量
						let jfsl = 0
						let zzl = 0
						let hj = 0
						for(let i of this.rcddhw){
							jfsl += parseFloat(i.jfsl)
							zzl += parseFloat(i.zzl)
						}
						
						this.jfsl = jfsl.toFixed(2)
						this.zzl = zzl.toFixed(2)
						hj = jfsl
						
						this.hj = hj.toFixed(2)
					}
				}else if(this.lists.jfdw == 3){ // 板
					this.rcddhw[index].jfsl = this.rcddhw[index].bsl
					this.rcddhw[index].zzl = (zl * js).toFixed(2) // 总重量
					let jfsl = 0
					let zzl = 0
					let hj = 0
					for(let i of this.rcddhw){
						jfsl += parseFloat(i.jfsl)
						zzl += parseFloat(i.zzl)
					}
					
					this.jfsl = jfsl.toFixed(2)
					this.zzl = zzl.toFixed(2)
					hj = jfsl
					this.hj = hj.toFixed(2)
				}else if(this.lists.jfdw == 4){ // 件
					this.rcddhw[index].jfsl = js
					this.rcddhw[index].zzl = (zl * js).toFixed(2) // 总重量
					let jfsl = 0
					let zzl = 0
					let hj = 0
					for(let i of this.rcddhw){
						jfsl += parseFloat(i.jfsl)
						zzl += parseFloat(i.zzl)
					}
					
					this.jfsl = jfsl.toFixed(2)
					this.zzl = zzl.toFixed(2)
					hj = jfsl
					this.hj = hj.toFixed(2)
				}

			},
			// 搜索事件
			searchEvent(e = false) {
				// 简单搜索
				if (typeof e === 'string') {
					this.search.keyword = e
					this.getList()
					return
				}
				// 高级搜索
				this.getList()
			},
			// 清空筛选条件
			clearSearch() {
				this.search = {
					keyword: "",
					bh: '',
				}
			},
			//提交
			submit() {
				this.lists.hj = this.hj
				this.lists.jfsl = this.jfsl
				
				if(this.zzl != 0){
					this.lists.zzl = this.zzl
				}
				
				if(this.lists.hwsl != 0){
					this.lists.rcddhw = this.rcddhw
					let hwzjs = 0
					let hwzds = 0
					let hwzmj = 0
					let hwzbs = 0
					for(let i of this.rcddhw){
						hwzjs += i.js
						hwzds += parseFloat(i.zzl)
						hwzmj += parseFloat(i.mj)
						hwzbs += parseFloat(i.bsl)
					}
					this.lists.hwzjs = hwzjs
					this.lists.hwzds = hwzds
					this.lists.hwzmj = hwzmj
					this.lists.hwzbs = hwzbs
				}
				let x = this.lists
				this.layout.showLoading()
				let url = this.lists.id === 0 ? '/admin/jh_rcdd' : '/admin/jh_rcdd/' + this.lists.id
				
				this.axios.post(url, x, {
					token: true
				}).then(res => {
					console.log(res);
					this.$message({
						type: "success",
						message: this.lists.id === 0 ? "下单成功" : "修改成功"
					})
					this.$router.push({
						name: "rcgl_ddcl_jhdd"
					})
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
	    margin-bottom: 4px !important;
	}
	.pt-a{
		padding-top: 20px;
	}
	.el-form-item__label {
		width: 84px !important;
	}
</style>
